module.exports = __webpack_public_path__ + "static/media/favcafeatnus.27523d1d.jpeg";